import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'printf'})
export class PrintfPipe implements PipeTransform {
  transform(format: string, ...args: any[]): string {
    if (!format) return '';

    let i = 0;

    return format.replace(/%(\d+\$)?([0-9]*)(?:\.([0-9]+))?([sdif])/g, (_, pos, width, precision, type) => {
      // Determine which argument to use
      const index = pos ? parseInt(pos, 10) - 1 : i++;
      let arg = args[index];

      if (arg === undefined || arg === null) return '';

      // Apply type conversion
      switch (type) {
        case 'd':
        case 'i':
          arg = parseInt(arg, 10);
          if (isNaN(arg)) arg = 0;
          break;
        case 'f':
          const prec = precision ? parseInt(precision, 10) : 6;
          arg = parseFloat(arg).toFixed(prec);
          break;
        case 's':
        default:
          arg = String(arg);
      }

      // Apply width and zero-padding
      if (width) {
        const padChar = width.startsWith('0') ? '0' : ' ';
        const padLen = parseInt(width, 10);
        arg = String(arg).padStart(padLen, padChar);
      }

      return arg;
    });
  }
}